<template>
    <div>
      <h1>About</h1>
    </div>
</template>

<script>
    export default {
        name: "About"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/About.vue